import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  InvoiceCreateWrapper: {
    margin: theme.spacing(1, 'auto')
  }
}))
